import { combineReducers } from 'redux';
import { memberListReducer } from 'features/member/reducer/memberListSlice';
import { connectMemberListReducer } from 'features/member/reducer/connectMemberListSlice';
import { backOrderReducer } from 'features/member/reducer/backorderSlice';
import { memberDetailReducer } from 'features/member/reducer/memberDetailSlice';

export default combineReducers({
  memberList: memberListReducer,
  connectMemberList: connectMemberListReducer,
  backOrder: backOrderReducer,
  memberDetail: memberDetailReducer,
});
